// MasterDashboardPinPad — Feb 2026 (Randy pt89f). Compact 4-digit PIN pad
// that fits on iPad landscape without overflow. Infinite retries per spec.
// pt89f: shrunk from max-w-sm+p-8 to max-w-[280px]+p-5, keys down to h-11,
// added explicit Cancel button + tap-outside to dismiss, max-h-[90vh].
import { useState } from "react";

const KEYS = ["1","2","3","4","5","6","7","8","9","","0","⌫"];

export default function MasterDashboardPinPad({ heading = "Enter PIN", onCancel, onSubmit }) {
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const tap = (k) => {
    if (busy) return;
    if (k === "⌫") { setPin((p) => p.slice(0, -1)); return; }
    if (!k) return;
    if (pin.length >= 4) return;
    const next = pin + k;
    setPin(next);
    if (next.length === 4) {
      setBusy(true);
      Promise.resolve(onSubmit(next)).finally(() => { setBusy(false); setPin(""); });
    }
  };
  return (
    <div className="fixed inset-0 z-[300] bg-black/80 backdrop-blur-md flex items-center justify-center p-4"
      onClick={() => !busy && onCancel?.()} data-testid="master-dashboard-pin-pad">
      <div className="bg-[#12151A] border border-white/10 rounded-2xl w-full max-w-[280px] max-h-[90vh] overflow-y-auto p-5"
        onClick={(e) => e.stopPropagation()}>
        <div className="text-center">
          <div className="font-serif-display text-lg text-white">{heading}</div>
          <div className="text-[9px] uppercase tracking-[0.28em] text-white/40 mt-0.5 mb-4">Parent PIN required</div>
          <div className="flex items-center justify-center gap-2.5 mb-5" data-testid="master-dashboard-pin-dots">
            {[0,1,2,3].map((i) => (
              <span key={i} className={`w-3 h-3 rounded-full border ${i < pin.length ? "bg-white border-white" : "bg-transparent border-white/25"}`} />
            ))}
          </div>
          <div className="grid grid-cols-3 gap-2">
            {KEYS.map((k, i) => (
              <button key={i} onClick={() => tap(k)} disabled={!k || busy}
                data-testid={k ? `master-dashboard-pin-key-${k === "⌫" ? "back" : k}` : `master-dashboard-pin-key-empty-${i}`}
                className={`h-11 rounded-lg text-xl font-light ${!k ? "invisible" : "bg-white/5 hover:bg-white/10 text-white border border-white/8 active:bg-white/20"}`}>
                {k}
              </button>
            ))}
          </div>
          <button onClick={() => !busy && onCancel?.()} data-testid="master-dashboard-pin-cancel"
            className="w-full mt-4 text-[10px] uppercase tracking-[0.22em] px-3 py-2 text-white/50 hover:text-white/80 border border-white/10 rounded-md">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
